// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1nQkK","left":"left-14Zmk","right":"right-_h7VN","right-inner":"right-inner-1OF8D","code":"code-3zpBU","message":"message-1icDK","buttons":"buttons-3gIsL"};